import { DATA_NEW_SNACKBAR_MESSAGE } from '@weblite/action/snackbar'
import { serverSub } from '$func/subscription'

serverSub.subscribe(
  DATA_NEW_SNACKBAR_MESSAGE,
  ({ type = 'error', autoHideDuration, id }) => {},
  // showSystemSnackbar({ type, id }, autoHideDuration),
)
